   // check4dnr/src/context/UserContext.js
   import React, { createContext, useState, useEffect } from 'react';

   export const UserContext = createContext({
     userGuid: null,
     firstName: '',
     lastName: '',
     email: '',
     accessToken: null,
     idToken: null,
     refreshToken: null,
     setUserGuid: () => {},
     setFirstName: () => {},
     setLastName: () => {},
     setEmail: () => {},
     setTokens: () => {},
     clearUser: () => {},
   });

   export const UserProvider = ({ children }) => {
     const [userGuid, setUserGuid] = useState(null);
     const [firstName, setFirstName] = useState('');
     const [lastName, setLastName] = useState('');
     const [email, setEmail] = useState('');
     const [accessToken, setAccessToken] = useState(null);
     const [idToken, setIdToken] = useState(null);
     const [refreshToken, setRefreshToken] = useState(null);

     // Load tokens and user info from localStorage on initial render
     useEffect(() => {
       const storedAccessToken = localStorage.getItem('accessToken');
       const storedIdToken = localStorage.getItem('idToken');
       const storedRefreshToken = localStorage.getItem('refreshToken');
       const storedUserGuid = localStorage.getItem('userGuid');
       const storedFirstName = localStorage.getItem('firstName');
       const storedLastName = localStorage.getItem('lastName');
       const storedEmail = localStorage.getItem('email');

       if (storedAccessToken && storedIdToken && storedRefreshToken) {
         setAccessToken(storedAccessToken);
         setIdToken(storedIdToken);
         setRefreshToken(storedRefreshToken);
         setUserGuid(storedUserGuid);
         setFirstName(storedFirstName);
         setLastName(storedLastName);
         setEmail(storedEmail);
       }
     }, []);

     const setTokens = (tokens) => {
       setAccessToken(tokens.accessToken);
       setIdToken(tokens.idToken);
       setRefreshToken(tokens.refreshToken);
       localStorage.setItem('accessToken', tokens.accessToken);
       localStorage.setItem('idToken', tokens.idToken);
       localStorage.setItem('refreshToken', tokens.refreshToken);
     };

     const setUserInformation = ({ userGuid, firstName, lastName, email }) => {
       setUserGuid(userGuid);
       setFirstName(firstName);
       setLastName(lastName);
       setEmail(email);
       localStorage.setItem('userGuid', userGuid);
       localStorage.setItem('firstName', firstName);
       localStorage.setItem('lastName', lastName);
       localStorage.setItem('email', email);
     };

     const clearUser = () => {
       setUserGuid(null);
       setFirstName('');
       setLastName('');
       setEmail('');
       setAccessToken(null);
       setIdToken(null);
       setRefreshToken(null);
       localStorage.removeItem('accessToken');
       localStorage.removeItem('idToken');
       localStorage.removeItem('refreshToken');
       localStorage.removeItem('userGuid');
       localStorage.removeItem('firstName');
       localStorage.removeItem('lastName');
       localStorage.removeItem('email');
     };

     return (
       <UserContext.Provider
         value={{
           userGuid,
           firstName,
           lastName,
           email,
           accessToken,
           idToken,
           refreshToken,
           setUserGuid,
           setFirstName,
           setLastName,
           setEmail,
           setTokens,
           setUserInformation,
           clearUser,
         }}
       >
         {children}
       </UserContext.Provider>
     );
   };